import { Component, Input } from "@angular/core";
import { PaymentOption } from "@models";

import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { FiatTransaction } from "@models/transaction";
import { FiatWithdrawalFraudComponent } from "@modules/main/components/step-summary/success-screens/fiat-withdraw-fraud/fiat-withdrawal-fraud.component";
import { CustomModal } from "@modules/core/components/base-modals";
import { DepositFailedComponent } from "@modules/main/components/step-summary/success-screens/deposit-end-screens/deposit-failed/deposit-failed.component";
import { MasterdataService } from "@core-services/masterdata.service";
import { Subscription } from "rxjs";
import { DepositSuccessComponent } from "@modules/main/components/step-summary/success-screens/deposit-end-screens/deposit-success/deposit-success.component";

@Component({
	selector: "deposit-pending",
	templateUrl: "./deposit-pending.component.html",
	styleUrls: ["./../success-screen.component.scss"],
	standalone: false
})
export class DepositPendingComponent extends CustomModal {
	@Input()
	public transaction: FiatTransaction;

	@Input()
	public isSavings: boolean = false;

	private timer: number = null;
	private sub: Subscription = null;

	public get paymentOption(): PaymentOption {
		return this.masterdata.getPaymentOptionById(this.transaction.getPaymentOptionId());
	}

	public constructor(
		private masterdata: MasterdataService,
		private fiatwalletService: FiatWalletService
	) {
		super();

		this.modalService.getCurrentModal().onDismiss.subscribe(() => {
			if (this.sub) {
				this.sub.unsubscribe();
			}
		});

		let time = 3;
		this.timer = window.setInterval(() => {
			if (--time <= 0) {
				clearInterval(this.timer);
				this.shortcutPaymentUrl();
			}
		}, 1000);
	}

	public shortcutPaymentUrl(): void {
		if (this.sub) {
			this.sub.unsubscribe();
		}
		this.sub = this.fiatwalletService
			.handleExternalRedirect(this.transaction)
			.subscribe((event: "canceled" | "finished") => {
				this.modalService.getCurrentModal().dismiss();
				// TODO: eslint fix
				/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
				let modalComponent: any = DepositFailedComponent;

				if (event === "finished") {
					if (this.transaction.isWithdrawalFraud()) {
						modalComponent = FiatWithdrawalFraudComponent;
					} else {
						if (this.isSavings) {
							return;
						}
						modalComponent = DepositSuccessComponent;
					}
				}

				this.modalService
					.create(
						modalComponent,
						{
							fiatTransaction: this.transaction,
							isSavings: this.isSavings
						},
						{ backButtonRoleDismiss: true }
					)
					.present();
			});
	}

	public done(): void {
		this.modalService.pop();
	}

	public cancelTimer(): void {
		clearInterval(this.timer);
		this.timer = null;
		this.shortcutPaymentUrl();
	}
}
